import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="pt-28 pb-16 md:pt-36 md:pb-24">
      <div className="container mx-auto px-4 relative">
        <div className="absolute inset-0 -z-10 mx-0 max-w-full overflow-hidden">
          <div
            className="absolute left-1/2 top-0 -z-10 -translate-x-1/2 blur-3xl xl:-top-6"
            aria-hidden="true"
          >
            <div
              className="aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-cultry-primary to-cultry-secondary opacity-30"
              style={{
                clipPath:
                  "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
              }}
            />
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-4xl md:text-6xl font-bold tracking-tight animate-fade-in">
            {t("heroSection.title")}
          </h1>
          <p className="mt-6 text-lg text-muted-foreground animate-fade-in animate-delay-300">
            {t("heroSection.description")}
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center animate-fade-in animate-delay-600">
            <Button size="lg" asChild>
              <Link to="/register">
                {t("heroSection.getStarted")}{" "}
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
            </Button>
            <Button size="lg" variant="outline" asChild>
              <Link to="#features">{t("heroSection.seeFeatures")}</Link>
            </Button>
          </div>
        </div>

        {/* Hero image */}
        <div className="mt-16 animate-fade-in animate-delay-900">
          <div className="relative mx-auto max-w-4xl">
            <div className="glass-morphism p-3 rounded-2xl shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1617347454431-f49d7ff5c3b1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80"
                alt={t("heroSection.dashboardAlt")}
                className="rounded-xl w-full"
              />
              <div className="absolute -bottom-5 -right-5 bg-background rounded-lg shadow-lg p-2 animate-float">
                <img
                  src="https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://xerven.com/menu/123"
                  alt={t("heroSection.qrCodeAlt")}
                  className="h-20 w-20"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
